import { Constants } from '../../../data/types'
import { useSetBusinessErrors } from '@src/data/selectors/app-config-selectors'
import { Document, DocumentRequired } from '../../../data/types/DocumentSchema'
import { EFinancingProgram } from '@if/core/types'
import { useTranslation } from 'react-i18next'
import { UploadAreaButton } from '@if/mui'

interface Props {
  documentRequired: DocumentRequired
  financingProgramId: EFinancingProgram
  sendDocs: (documentList: Document[], files: File[]) => void
  isUploading: boolean
}

function isAcceptedFile(file: File) {
  const acceptedTypes = Constants.SupportedDocumentTypes.split(',').map((type) => type.trim().toLowerCase())
  const fileType = file.type.toLowerCase()
  const fileName = file.name.toLowerCase()
  return acceptedTypes.some((type) => (type.startsWith('.') ? fileName.endsWith(type) : fileType === type))
}

export const DocumentUploadArea = ({
  documentRequired,
  financingProgramId,
  sendDocs,
  isUploading,
}: Props) => {
  const { t } = useTranslation()
  const setBusinessErrors = useSetBusinessErrors()

  const handleFiles = (files: FileList | null) => {
    if (files && files.length > 0) {
      const file = files[0]
      if (isAcceptedFile(file)) {
        const doc = {
          applicantType: documentRequired.applicantType,
          typeId: Number(documentRequired.typeId),
          note: '',
          creditApplicationId: documentRequired.creditApplicationId,
          financingProgramId,
          isPrivate: false,
          subKey: documentRequired.subKey,
          fileName: `0-${file.name}`,
        } as Document
        sendDocs([doc], [file])
      } else {
        setBusinessErrors([
          {
            message: t('document.unsupportedFileType'),
            params: { supportedTypes: Constants.SupportedDocumentTypes },
          },
        ])
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    }
  }

  return (
    <UploadAreaButton
      color="primary"
      loading={isUploading}
      accept={Constants.SupportedDocumentTypes}
      onChange={(e) => handleFiles(e.target.files)}
      size="large"
    >
      {t('document.uploadDocument')}
    </UploadAreaButton>
  )
}
